/**
 * The icon set, assembled by hand.
 *
 * The design system's Icon component looks names up in `window.lucide.icons`.
 * Importing lucide's barrel would pull in all ~1743 icons and add roughly
 * 700 kB for the few dozen this app uses, so each is imported individually and
 * the lookup table is built here — same approach as website-main and Cloud.
 *
 * Icon renders `icons[pascal(name)] || icons[name]`, so keys are PascalCase.
 * A missing entry renders nothing at all rather than throwing, so grep this
 * file first if an icon goes blank.
 *
 * Kept to what Review actually draws. The mockups reference Phosphor glyphs by
 * name because they were built from Compose's Qt icon font; the web apps use
 * Lucide, so the nearest Lucide name is used and the two are not expected to
 * match glyph for glyph.
 */

import {
  AlertTriangle,
  Archive,
  ArrowLeft,
  ArrowRight,
  AtSign,
  Bell,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronRight,
  Clock,
  Copy,
  Download,
  ExternalLink,
  Eye,
  Filter,
  Image,
  Link2,
  List,
  Loader2,
  Lock,
  LogOut,
  MessageCircle,
  MessageSquare,
  MoreHorizontal,
  Paperclip,
  Play,
  Plus,
  Reply,
  Search,
  Send,
  Settings,
  Share2,
  ShieldAlert,
  Trash2,
  User,
  Users,
  X
} from 'lucide';

export const iconSet: Record<string, unknown> = {
  AlertTriangle,
  Archive,
  ArrowLeft,
  ArrowRight,
  AtSign,
  Bell,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronRight,
  Clock,
  Copy,
  Download,
  ExternalLink,
  Eye,
  Filter,
  Image,
  Link2,
  List,
  Loader2,
  Lock,
  LogOut,
  MessageCircle,
  MessageSquare,
  MoreHorizontal,
  Paperclip,
  Play,
  Plus,
  Reply,
  Search,
  Send,
  Settings,
  Share2,
  ShieldAlert,
  Trash2,
  User,
  Users,
  X
};
